/**
 * [string, string]: [background, text]
 */
export var palletes = {
    greenWhite: { color: 'green60', textColor: 'white' },
    blueBlue: { color: 'blue20', textColor: 'blue80' },
    magentaWhite: { color: 'magenta60', textColor: 'white' },
    magentaMagenta: { color: 'magenta20', textColor: 'magenta80' },
    tealTeal: { color: 'teal20', textColor: 'teal90' },
    orangeOrange: { color: 'orange20', textColor: 'orange80' },
    grayGray: { color: 'neutral20', textColor: 'typoPrimary' },
    redWhite: { color: 'red1', textColor: 'white' },
    redRed: { color: 'red30', textColor: 'red1' },
    purplePurple: { color: 'purple20', textColor: 'purple80' }
};
